import { LayoutBand, Separator } from '@fs/zion-ui'
import React from 'react'
import SkeletonAnimationSyncDecorator from '../../../common/SkeletonAnimationSyncDecorator'
import ContributionsHeaderSkeleton from './ContributionsHeader/ContributionsHeaderSkeleton'
import ContributionsActionBarSkeleton from './ContributionsActionBar/ContributionsActionBarSkeleton'
import CenteredLoadingSpinner from '../../../common/CenteredLoadingSpinner'

export default function ContributionsPageSkeleton(): JSX.Element {
  return (
    <SkeletonAnimationSyncDecorator>
      <ContributionsHeaderSkeleton />

      <LayoutBand maxWidth="xxl">
        <Separator size="xxs" />
        <ContributionsActionBarSkeleton />
        <CenteredLoadingSpinner />
        {/* Switch to ContributionsViewSkeleton once  ContributionsPage is the default experience as opposed to ChangeLogPage */}
        {/* <ContributionsViewSkeleton /> */}
      </LayoutBand>
      <Separator />
    </SkeletonAnimationSyncDecorator>
  )
}
